import Tag from "components/Tag"

import { ComponentProps } from "."
import { TechSpecsUl } from "./styled"

const List = ({ onAdd, onRemove, techSpecsAndColor }: ComponentProps) => (
  <TechSpecsUl aria-label="Tech Specs">
    {techSpecsAndColor?.map(({ color, techSpec }) => (
      <li aria-label={techSpec.join(" ")} key={techSpec.join(" ")}>
        <Tag
          color={color}
          label={techSpec.join(" ")}
          onClick={onAdd ? onAdd(techSpec) : undefined}
          onRemove={onRemove ? onRemove(techSpec) : undefined}
        />
      </li>
    ))}
  </TechSpecsUl>
)

List.whyDidYouRender = true
export default List
